
import Vue from 'vue';

export default Vue.extend({
	name: 'EnterpriseUpsellBadge',
	props: {
		size: { type: Number, required: true },
		iconSize: { type: Number, required: true },
	},
});
